import { Connector } from '@components/connectors/Connector'
import { AvailableAppConnector } from '@components/connectors/Summary'
import FormCard from '@components/FormCard'
import { useHasAccess } from '@components/HasAccess'
import { Venue } from '@models/Venue'
import { VenueIntegrationProduct } from '@models/venue/VenueIntegration'
import { SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { Permission } from '@utils/permissions'
import { Card, Collapse, Flex, Space, Typography } from 'antd'

const { Title, Text } = Typography

interface Props {
  enable?: boolean
  title: React.ReactNode
  venue: Venue
  demoData: {
    title?: React.ReactNode
    description?: string
    imageUrl?: string
    action?: React.ReactNode
  }
  availableConnectors: AvailableAppConnector[]
  product: VenueIntegrationProduct
  enableBookingFormSections: string[]
  footer?: React.ReactNode
}

export const PlatformBookingCard = ({
  enable,
  title,
  venue,
  demoData,
  availableConnectors,
  product,
  enableBookingFormSections,
  footer,
}: Props) => {
  const { hasAccess } = useHasAccess()
  return (
    <>
      {enable ? (
        <Collapse
          className="booking-collapse"
          collapsible={'disabled'}
          expandIcon={() => undefined}
          items={[
            {
              key: '1',
              label: (
                <Flex className="w-full" justify="space-between" align="center">
                  <Title level={5} className="m-0">
                    {title}
                  </Title>
                  <FormCard
                    autoSize
                    noCardWrap
                    saveOnChange
                    entity={Entity.venue}
                    action={SBRMAction.Update}
                    sections={enableBookingFormSections}
                    disabled={!hasAccess(Permission.updateVenue)}
                  />
                </Flex>
              ),
              children: (
                <Flex vertical gap={16}>
                  <Connector.Wrapper
                    availableConnectors={availableConnectors}
                    product={product}
                    venue={venue}
                  />
                  {footer}
                </Flex>
              ),
            },
          ]}
          activeKey={enable ? ['1'] : undefined}
        />
      ) : (
        <Card styles={{ body: { padding: 0, paddingLeft: 50 } }}>
          <Flex align="center" gap={50}>
            {demoData.imageUrl && (
              <img src={demoData.imageUrl} style={{ maxWidth: 450 }} />
            )}
            <Space orientation="vertical" style={{ maxWidth: 350 }}>
              <Title className={'m-0'} level={5}>
                {demoData.title}
              </Title>
              <Text>{demoData.description}</Text>
              <Flex align="center">{demoData.action}</Flex>
            </Space>
          </Flex>
        </Card>
      )}
    </>
  )
}

export type PlatformBookingCardType = {
  BookingCard: typeof PlatformBookingCard
}
